import { render, staticRenderFns } from "./CustomFieldValue.vue?vue&type=template&id=5b0c2710&scoped=true&"
import script from "./CustomFieldValue.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFieldValue.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c2710",
  null
  
)

export default component.exports